import React, { type FC, useRef } from 'react';
import { type FieldValues, useForm } from 'react-hook-form';
import { Toast } from 'primereact/toast';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const ForgotPassword: FC = () => {
    const toast = useRef<Toast>(null);
    const navigate = useNavigate();

    const [searchParameters] = useSearchParams();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = async (data: FieldValues) => {
        const { success, message } = await api.setForgottenPassword(
            data.password as string,
            searchParameters.get('token') ?? '',
        );
        if (success) {
            toast.current?.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Password Reset',
            });
            setTimeout(() => {
                navigate('/');
            }, 1000);
        } else {
            toast.current?.show({
                severity: 'warn',
                summary: 'Password Reset Failed',
                detail: message ?? 'unknown error',
            });
        }
    };

    return (
        <div className="w-full h-full flex justify-center items-center">
            <Toast ref={toast} position="top-right" />
            <form
                className="flex flex-col justify-center items-center"
                onSubmit={handleSubmit(onSubmit)}
            >
                <h1 className="text-primary text-2xl">Reset Password</h1>
                <input
                    type="password"
                    placeholder="new password"
                    defaultValue=""
                    {...register('password', { required: true })}
                    className="input input-bordered input-primary text-primary m-2"
                />
                {errors.password && (
                    <span className="text-red-500 mb-2">
                        This field is required
                    </span>
                )}
                <input type="submit" className="btn btn-primary m-2" />
            </form>
        </div>
    );
};

export default ForgotPassword;
